



























































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Consulting"
})
export default class Consulting extends Vue {}
